import { EPravidlaOdkupu } from 'enums/isin/udaje/pravidlaOdkupu';

const pravidlaOdkupuSelect = [
    {
        value: EPravidlaOdkupu.O,
        labelcz: 'ISIN_EMISE_AKCIE_ODKUP_ODKUP'
    },
    {
        value: EPravidlaOdkupu.P,
        labelcz: 'ISIN_EMISE_AKCIE_ODKUP_PRODLOUZENI'
    },
    {
        value: EPravidlaOdkupu.OP,
        labelcz: 'ISIN_EMISE_AKCIE_ODKUP_ODKUP_PRODLOUZENI'
    },
    {
        value: EPravidlaOdkupu.V,
        labelcz: 'ISIN_EMISE_AKCIE_ODKUP_VYMENITELNE'
    },
    {
        value: EPravidlaOdkupu.OVP,
        labelcz: 'ISIN_EMISE_AKCIE_ODKUP_ODKUP_VYMENITELNE'
    },
    {
        value: EPravidlaOdkupu.OV,
        labelcz: 'ISIN_EMISE_AKCIE_ODKUP_ODKUP_VYMENITELNE_PRODLOUZENI'
    },
    {
        value: EPravidlaOdkupu.VE,
        labelcz: 'ISIN_EMISE_AKCIE_ODKUP_VECNE'
    }
];

export default pravidlaOdkupuSelect;
